export default class ContactWidget {
    private rootElement: HTMLElement;

    constructor(uniqueID: string) {
        this.rootElement = document.getElementById(uniqueID) as HTMLElement;
        if (!this.rootElement) return;

        this.initialise();
    }

    private initialise() {
        const headerTabs = this.rootElement.querySelectorAll<HTMLButtonElement>("button.tab__title");
        const contentSections = Array.from(this.rootElement.querySelectorAll<HTMLElement>(".tab__body"));

        headerTabs?.forEach((header, index) => {
            header.addEventListener("click", () => this.activateTab(headerTabs, contentSections, index));
            header.addEventListener("keydown", (event) => this.handleKeyNavigation(event, headerTabs, contentSections, index));
        });

        contentSections.forEach((section) => {
            section.addEventListener("keydown", (event) => this.handleContentKeyNavigation(event, headerTabs));
        });

        this.matchHeights(contentSections, true);
        this.updateWidgetsWithinSection();
    }

    private activateTab(headerTabs: NodeListOf<HTMLButtonElement>, contentSections: HTMLElement[], index: number) {
        headerTabs.forEach((tab, i) => {
            const isActive = i === index;
            tab.tabIndex = isActive ? 0 : -1;
            tab.setAttribute("aria-selected", String(isActive));
            tab.classList.toggle("active", isActive);
        });

        contentSections.forEach((panel, i) => {
            const isActive = i === index;
            panel.classList.toggle("active", isActive);
            panel.style.display = isActive ? "block" : "none";
            panel.tabIndex = isActive ? 0 : -1;
        });

        this.matchHeights(contentSections, true);
    }

    private handleKeyNavigation(event: KeyboardEvent, headerSections: NodeListOf<HTMLButtonElement>, contentSections: HTMLElement[], index: number) {
        const keyMap: { [key: string]: number } = {
            ArrowRight: 1,
            ArrowLeft: -1,
            Home: 0,
            End: headerSections.length - 1,
        };

        if (keyMap[event.key] !== undefined) {
            event.preventDefault();
            const newIndex = event.key === "Home" || event.key === "End"
                ? keyMap[event.key]
                : (index + keyMap[event.key] + headerSections.length) % headerSections.length;

            headerSections[newIndex].focus();
            headerSections[newIndex].click();
        } else if (event.key === "Tab" && !event.shiftKey) {
            event.preventDefault();
            contentSections[index].focus();
        }
    }

    private handleContentKeyNavigation(event: KeyboardEvent, headerTabs: NodeListOf<HTMLButtonElement>) {
        if (event.key === "Tab" && event.shiftKey) {
            event.preventDefault();

            const activeTab = Array.from(headerTabs).find(tab => tab.classList.contains("active"));

            if (activeTab) {
                activeTab.focus();
            }
        }
    }

    private matchHeights(contentSections: HTMLElement[], hideInactiveElements: boolean) {
        let maxHeight = 0;

        // Temporarily show all sections to measure height
        contentSections.forEach((section) => {
            if (hideInactiveElements) {
                section.style.visibility = "hidden";
                section.style.display = "block";
            }
            section.style.height = "auto";
            maxHeight = Math.max(maxHeight, section.offsetHeight);
            if (hideInactiveElements) {
                section.style.visibility = "visible";
            }
        });

        // Apply max height to all
        contentSections.forEach(section => section.style.height = `${maxHeight}px`);

        // Hide inactive sections again
        if (hideInactiveElements) {
            contentSections.forEach(section => {
                if (!section.classList.contains("active")) {
                    section.style.display = "none";
                }
            });
        }
    }

    private updateWidgetsWithinSection() {
        const currentSection = this.rootElement.closest('.flex-column-section-container, .grid-Section-container') ?? this.rootElement.closest('.widget-container');
        const sectionContactWidgets = Array.from(currentSection?.querySelectorAll<HTMLElement>('.contact__widget'));
        if (sectionContactWidgets.includes(this.rootElement)) {
            this.matchHeights(sectionContactWidgets, false);
        }
    }
}